import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import LocalizedLink from '../../../../components/LocalizedLink';

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

const pricingPlans = [
  {
    name: "Starter",
    nameId: "landing.pricing.starter.name",
    price: "29",
    tokens: "50 tokens inclus",
    tokensId: "landing.pricing.starter.tokens",
    features: [
      { id: "landing.pricing.starter.f1", default: "Accès à toutes les applications" },
      { id: "landing.pricing.starter.f2", default: "Gestion de projets illimitée" },
      { id: "landing.pricing.starter.f3", default: "Visualisation BIM" },
      { id: "landing.pricing.starter.f4", default: "Support par email" }
    ],
    featured: false,
    ctaStyle: "outline",
    ctaId: "landing.pricing.cta.start",
    ctaDefault: "Commencer"
  },
  {
    name: "Pro",
    nameId: "landing.pricing.pro.name",
    price: "99",
    tokens: "250 tokens inclus",
    tokensId: "landing.pricing.pro.tokens",
    features: [
      { id: "landing.pricing.pro.f1", default: "Tout Starter +" },
      { id: "landing.pricing.pro.f2", default: "Support prioritaire" },
      { id: "landing.pricing.pro.f3", default: "Historique complet" },
      { id: "landing.pricing.pro.f4", default: "Workflows IA (bêta)" }
    ],
    featured: true,
    ctaStyle: "blue",
    ctaId: "landing.pricing.cta.start",
    ctaDefault: "Commencer"
  },
  {
    name: "Enterprise",
    nameId: "landing.pricing.enterprise.name",
    price: "299",
    tokens: "1 000 tokens inclus",
    tokensId: "landing.pricing.enterprise.tokens",
    features: [
      { id: "landing.pricing.enterprise.f1", default: "Tout Pro +" },
      { id: "landing.pricing.enterprise.f2", default: "Accès API complet" },
      { id: "landing.pricing.enterprise.f3", default: "Support dédié" },
      { id: "landing.pricing.enterprise.f4", default: "Rapports personnalisés" }
    ],
    featured: false,
    ctaStyle: "outline",
    ctaId: "landing.pricing.cta.contact",
    ctaDefault: "Nous contacter",
    ctaTo: "/contact/?subject=enterprise"
  }
];

const PricingLanding = ({ intl: { locale } }) => {
  const isEn = locale === 'en';
  return (
    <section className="pricing-landing" id="pricing">
      <div className="pricing-container">
        <div className="section-header">
          <span className="section-tag">
            <FormattedMessage id="landing.pricing.tag" defaultMessage="Tarifs" />
          </span>
          <h2 className="section-title">
            <FormattedMessage
              id="landing.pricing.title"
              defaultMessage="Un modèle simple basé sur l'usage"
            />
          </h2>
          <p className="section-subtitle">
            <FormattedMessage
              id="landing.pricing.subtitle"
              defaultMessage="Payez uniquement ce que vous utilisez. Chaque token consommé rémunère directement les développeurs des applications."
            />
          </p>
        </div>
        <div className="pricing-grid">
          {pricingPlans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.featured ? 'featured' : ''}`}>
              <h3 className="pricing-name">
                <FormattedMessage id={plan.nameId} defaultMessage={plan.name} />
              </h3>
              <div className="pricing-price">
                <span className="pricing-amount">{isEn ? `€${plan.price}` : `${plan.price} €`}</span>
                <span className="pricing-period">{isEn ? '/month' : '/mois'}</span>
              </div>
              <p className="pricing-tokens">
                <FormattedMessage id={plan.tokensId} defaultMessage={plan.tokens} />
              </p>
              <ul className="pricing-features">
                {plan.features.map((feature, fIndex) => (
                  <li key={fIndex}>
                    <CheckIcon />
                    <FormattedMessage id={feature.id} defaultMessage={feature.default} />
                  </li>
                ))}
              </ul>
              {plan.ctaTo ? (
                <LocalizedLink
                  to={plan.ctaTo}
                  className={`btn-landing pricing-cta ${plan.ctaStyle === 'blue' ? 'btn-blue' : 'btn-outline'}`}
                >
                  <FormattedMessage id={plan.ctaId} defaultMessage={plan.ctaDefault} />
                </LocalizedLink>
              ) : (
                <a
                  href="https://platform.tridyme.com/"
                  className={`btn-landing pricing-cta ${plan.ctaStyle === 'blue' ? 'btn-blue' : 'btn-outline'}`}
                >
                  <FormattedMessage id={plan.ctaId} defaultMessage={plan.ctaDefault} />
                </a>
              )}
            </div>
          ))}
        </div>
        <div className="pricing-note">
          <p>
            <FormattedMessage
              id="landing.pricing.note"
              defaultMessage="Besoin de plus de tokens ? Achetez des tokens supplémentaires à"
            />
            {' '}<strong>{isEn ? '€0.50 / token' : '0,50 € / token'}</strong>.{' '}
            <FormattedMessage
              id="landing.pricing.note2"
              defaultMessage="Chaque token utilisé rémunère directement le développeur de l'application."
            />
          </p>
        </div>
      </div>
    </section>
  );
};

export default injectIntl(PricingLanding);
